"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProviderPage = void 0;
var keys_1 = require("../../keys");
var react_1 = require("react");
var useQuery_1 = require("../../useQuery");
var useProviderPage = function (_a) {
    var slug = _a.slug;
    var _b = (0, useQuery_1.useQuery)({
        canRender: !!slug,
        path: keys_1.GET_PROVIDER_PAGE,
        payload: {
            slug: slug,
        },
        revalidateOnMount: true,
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, mutate = _b.mutate, isValidating = _b.isValidating;
    return (0, react_1.useMemo)(function () { return ({
        mutate: mutate,
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    }); }, [data, isLoading, isValidating, mutate, error]);
};
exports.useProviderPage = useProviderPage;
